import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import withAuthentication from '@/src/shared/components/WithAuthentication';

const NCOIL = props => {
  return <ContentPage {...props} />;
};

export async function getStaticProps() {
  return {
    props: {
      sitepageid: 83651,
    },
  };
}

export default withAuthentication(NCOIL);
